<template>
  <div class="body">
    <div class="payment-success-container">
      <div class="payment-content">
        <div class="payment-success-title">
          <h1>{{ $t(`message.payment.paymentSuccessTitle`) }}</h1>
        </div>
        <div class="payment-success-content">
          <p>
            {{ $t(`message.payment.paymentSuccessContent`) }}
          </p>
          <p>
            {{ $t(`message.subscription.endsubscription`) }}
            {{ $d(getExpirationDate) }}
          </p>
        </div>
      </div>
      <div class="row button-container">
        <button class="pill" @click="$router.push({ name: 'PersonalHome' })">
          {{ $t(`message.account.accessMyAccount`) }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaymentSuccess",
  computed: {
    getExpirationDate() {
      return new Date(this.$store.state.users.user.subscription_expiry);
    },
  },
};
</script>

<style lang="scss" scoped>
.body {
  display: flex;
  justify-content: center;
  min-height: calc(100vh - 100px - 126px - 40px);

  .payment-success-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-image: url("../assets/subscription/planet-background.webp");
    background-size: cover;
    border-radius: 50px;
    width: 90%;
    padding-left: 6em;
    padding-right: 6em;
    min-height: 400px;
    margin-bottom: 40px;
    text-align: center;

    @media screen and (max-width: 600px) {
      .payment-success-container {
        margin: 10em !important;
      }
    }

    p {
      text-align: justify;
    }

    .payment-success-title {
      margin-bottom: 3rem;
      text-transform: uppercase;
      font-family: "Averia Sans Libre", sans-serif;
      font-weight: 800;
    }
  }

  .button-container {
    justify-content: center;
    padding: 10px;

    .pill {
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 130px;
      border: 3px solid $secondaryColor;
      background-color: $secondaryColor;
      color: $whiteColor;
      height: 40px;
      border-radius: 20px;
      font-weight: 800;
      padding: 0.25rem 1rem;
      text-transform: uppercase;
      font-family: "Averia Sans Libre", sans-serif;

      &:hover {
        border: 3px solid $secondaryColor;
        color: $secondaryColor;
        background-color: $backgroundColor;
      }
    }
  }
}
</style>
